import { useEffect, useState, useRef, useContext } from 'react';
import { DiscadorContext } from '../contexts';

export function useKeyboardInput(initialValue: string, maxLength: number = 11) {
  const [value, setValue] = useState(initialValue);
  const [keyDownEvent, setKeyDownEvent] = useState<KeyboardEvent | null>(null);
  const refValue = useRef(initialValue);
  const { getTelefoneChamada } = useContext(DiscadorContext);

  useEffect(() => {
    setKeyDownEvent(null);
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    refValue.current = value;
    getTelefoneChamada(value);
  }, [value]);

  function keyDownHandler(event: KeyboardEvent) {
    const { key } = event;
    setKeyDownEvent(event);
    if (key === 'Backspace') {
      setValue(refValue.current.slice(0, -1));
    } else {
      if (refValue.current.length < maxLength) setValue(refValue.current + key);
    }
  }

  function virtualInteraction(key: string) {
    keyDownHandler(new KeyboardEvent('keydown', { key }));
  }

  //   useEffect(() => {
  //     document.addEventListener("keydown", keyDownHandler);

  //     return function cleanup() {
  //       document.removeEventListener("keydown", keyDownHandler);
  //     };
  //   }, []);

  return { value, virtualInteraction };
}
